import React from 'react';
import { BodyText } from '@chargify/custom-ui-components';
import { formatCurrency } from '@chargify/formatters';
import { SerializedPrice } from '../../../machines';

export const renderPrice = (price: SerializedPrice, locale: string) => {
  if (Array.isArray(price.value))
    return (
      <BodyText variant="body2" color="success.main" fontWeight={700}>
        {formatCurrency(price.currency, price.value[0], locale)} -{' '}
        {formatCurrency(price.currency, price.value[1], locale)}
      </BodyText>
    );
  return (
    <BodyText variant="body2" color="success.main" fontWeight={700}>
      {formatCurrency(price.currency, price.value, locale)}
    </BodyText>
  );
};
